import React from "react";
import { Search } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BankLogo, COUNTRIES } from "./shared";

// Vista "aggiungi banca": selezione paese + ricerca + elenco istituti.
export const InstitutionPicker = ({
  status,
  country,
  setCountry,
  query,
  setQuery,
  institutions,
  filtered,
  connecting,
  onSelect,
}) => (
  <div data-testid="bank-select-view">
    <p className="text-sm font-light text-white/70">
      {status.connected ? "Aggiungi una banca" : "Scegli la tua banca"}
    </p>
    <p className="mt-1 text-[12px] font-light text-white/40">
      Verrai reindirizzato alla banca per autorizzare l'accesso in sola lettura.
    </p>

    {/* selettore paese */}
    <div className="mt-4">
      <label className="caps-tag mb-1.5 block text-white/40">Paese</label>
      <Select value={country} onValueChange={setCountry}>
        <SelectTrigger
          data-testid="bank-country-select"
          className="mono h-11 rounded-[8px] border-white/10 bg-[#0D0D14] text-sm font-light text-white"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="border-white/10 bg-[#0D0D14] text-white">
          {COUNTRIES.map((c) => (
            <SelectItem
              key={c.code}
              value={c.code}
              data-testid={`bank-country-${c.code}`}
              className="mono text-sm focus:bg-white/[0.06] focus:text-[#00FF87]"
            >
              {c.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    {/* ricerca */}
    <div className="mt-3 flex h-11 items-center gap-2 rounded-[8px] border border-white/10 bg-[#0D0D14] px-3">
      <Search size={15} className="text-white/35" />
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Cerca banca…"
        data-testid="bank-search-input"
        className="mono h-full flex-1 bg-transparent text-sm font-light text-white placeholder:text-white/30 focus:outline-none"
      />
    </div>

    <div className="mt-3 space-y-2" data-testid="bank-institutions-list">
      {institutions === null ? (
        [0, 1, 2, 3].map((i) => (
          <div key={i} className="h-14 animate-pulse rounded-[8px] border border-white/[0.06] bg-[#0D0D14]" />
        ))
      ) : filtered.length === 0 ? (
        <p className="mono py-8 text-center text-[12px] text-white/35">Nessuna banca trovata in questo paese</p>
      ) : (
        filtered.map((inst) => (
          <button
            key={inst.id}
            onClick={() => onSelect(inst)}
            disabled={!!connecting}
            data-testid={`bank-institution-${inst.id}`}
            className={`flex w-full items-center gap-3 rounded-[8px] border px-3 py-2.5 text-left active:scale-[0.99] disabled:opacity-50 ${
              inst.sandbox
                ? "border-[#FFD60A]/30 bg-[#FFD60A]/[0.04] hover:bg-[#FFD60A]/[0.08]"
                : "border-white/[0.07] bg-[#0D0D14] hover:bg-white/[0.04]"
            }`}
          >
            <BankLogo inst={inst} />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[13px] font-light text-white/85">{inst.name}</span>
              {inst.sandbox && <span className="caps-tag text-[#FFD60A]/70">Ambiente di test</span>}
            </span>
            {connecting === inst.id ? (
              <span className="flex items-center gap-1">
                <span className="liqo-thinking-dot" />
                <span className="liqo-thinking-dot" />
                <span className="liqo-thinking-dot" />
              </span>
            ) : (
              <span className="mono text-xs text-[#00FF87]/70">❯</span>
            )}
          </button>
        ))
      )}
    </div>
  </div>
);
